import type { ReactElement } from 'react';
import { RadioButton, type RadioButtonProps } from '#components/radio-button/radio-button';
import type { BooleanString } from '#components/radio-group-boolean/radio-group-boolean';

export type RadioButtonBooleanProps = Omit<RadioButtonProps<BooleanString>, 'value'> & {
  value: boolean;
};

export function RadioButtonBoolean({
  value,
  children,
  ...props
}: RadioButtonBooleanProps): ReactElement {
  return (
    <RadioButton<BooleanString> {...props} data-test-radio-boolean value={value ? 'true' : 'false'}>
      {children}
    </RadioButton>
  );
}
